'use client'

/* eslint-disable @next/next/no-img-element */
import { cn, Link } from '@gyym/ui'

import {
  type CorpLpBannerPlacement,
  pushCorpLpBannerClickEvent,
} from '@/lib/googleTagManager'

// Figma「法人プランLPバナー」を PC (1024x150 @2x) / SP (375x160 @3x) でラスタライズしたもの
const PC_IMAGE = '/assets/images/banner/corp-lp-banner-pc.webp'
const SP_IMAGE = '/assets/images/banner/corp-lp-banner-sp.webp'

// `tablet` ブレークポイント (600px) 以上で PC 版に切り替える
const PC_MEDIA = '(min-width: 600px)'

const ALT =
  '健やかな毎日を、職場のサポートでもっと身近に。多彩なウェルネスを支える 法人向け福利厚生プランのご案内'

export interface CorpLpBannerProps {
  className?: string
  /** 設置場所。クリック時に GTM へ送り、どの導線からの流入かを区別する */
  placement: CorpLpBannerPlacement
  /**
   * responsive: 画面幅に応じて PC / SP の画像を切り替える (ページ下部用)
   * sp: 常に SP の画像を使う (サイドメニューなど幅の狭い場所用)
   */
  size?: 'responsive' | 'sp'
  onClick?: () => void
}

/** 法人会員サービスLP (/corp) への導線バナー */
export const CorpLpBanner = ({
  className,
  placement,
  size = 'responsive',
  onClick,
}: CorpLpBannerProps) => (
  <Link
    href="/corp"
    onClick={() => {
      pushCorpLpBannerClickEvent(placement)
      onClick?.()
    }}
    className={cn('block w-full', className)}
  >
    <picture>
      {size === 'responsive' && (
        <source media={PC_MEDIA} srcSet={PC_IMAGE} width={2048} height={300} />
      )}
      <img
        src={SP_IMAGE}
        alt={ALT}
        width={1125}
        height={480}
        // ページ下部に置くため、スクロールで近づくまで読み込まない
        loading="lazy"
        decoding="async"
        className="block h-auto w-full"
      />
    </picture>
  </Link>
)
